var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRwaEarn = function SvgRwaEarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.532 11.502h2.024a4.197 4.197 0 0 1 4.197 4.198h-6.53l.001.933 7.461-.001V15.7c0-1.01-.296-1.962-.826-2.799h2.692a4.66 4.66 0 0 1 4.212 2.66c-2.206 2.91-5.777 4.802-9.808 4.802-2.576 0-4.757-.55-6.53-1.515l.002-8.678a6.5 6.5 0 0 1 3.105 1.332m-4.039 6.996a.933.933 0 0 1-.932.932H2.695a.933.933 0 0 1-.932-.932v-8.394c0-.515.417-.933.932-.933h1.866c.515 0 .932.418.932.933zM20.416 8.239a2.798 2.798 0 1 0-5.596 0 2.798 2.798 0 0 0 5.596 0M13.887 5.44a2.798 2.798 0 1 0-5.596 0 2.798 2.798 0 0 0 5.596 0"
  })));
};
export default SvgRwaEarn;